import type React from 'react';

import { BannerStateContainer } from '@confluence/banners';

export const databaseHeightContainer = [BannerStateContainer];
export const databaseShellStyle = (topNavAndBannerHeight: number): React.CSSProperties => ({
	width: '100%',
	height: `calc(100vh - ${topNavAndBannerHeight}px)`,
	display: 'block',
	border: '0px',
});
